module.exports = __webpack_public_path__ + "img/no_sent_request.25bf2eae.png";